<template>
  <vx-card title="Employee Category">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getEmployeeCategory"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].employeeCategoryId">
                      {{ data[indextr].employeeCategoryId }}
                    </vs-td>
                    <vs-td :data="data[indextr].employeeCategoryCode">
                      {{ data[indextr].employeeCategoryCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].employeeCategoryName">
                      {{ data[indextr].employeeCategoryName }}
                    </vs-td>
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].employeeCategoryId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(
                              data[indextr].employeeCategoryId
                            )
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD EMPLOYEE CATEGORY -->
      <vs-prompt
        class="email-compose"
        title="Add Employee Category "
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="employeeCategory.employeeCategoryCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="employeeCategory.employeeCategoryName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ADD EMPLOYEE CATEGORY -->

      <!-- EDIT EMPLOYEE CATEGORY -->
      <vs-prompt
        class="email-compose"
        title="Edit Employee Category"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="employeeCategory.employeeCategoryCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="employeeCategory.employeeCategoryName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT EMPLOYEE CATEGORY  -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      employeeCategory: {
        employeeCategoryId: 0,
        employeeCategoryCode: "",
        employeeCategoryName: "",
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllEmployeeCategory").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getEmployeeCategory() {
      return this.$store.state.lookup.getAllEmployeeCategory;
    },
    validForm() {},
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addEmployeeCategory", this.employeeCategory)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/employeeCategory"](id);

      (this.employeeCategory.employeeCategoryId = id),
        (this.employeeCategory.employeeCategoryCode = e.employeeCategoryCode),
        (this.employeeCategory.employeeCategoryName = e.employeeCategoryName),
        (this.activePromptEditRecord = true);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateEmployeeCategory", this.employeeCategory)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
